// extracted by mini-css-extract-plugin
module.exports = {"main":"asset_main__PGLna","title":"asset_title__NTv_o","btnDiv":"asset_btnDiv__bMm4P","ul":"asset_ul__lHBwM"};